import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect, useDispatch } from 'react-redux';
import { withRouter } from '@americanexpress/one-app-router';
import { clearError } from '@americanexpress/one-app-ducks';
import { FormattedMessage } from 'react-intl';
import {
  BackLink, Heading, Link, ProgressCircular,
} from '@americanexpress/dls-react';
import { IconWarning } from '@americanexpress/dls-icons';
import clsx from 'clsx';
import styles from './ErrorLayout.scss';

/**
 * Displays 404 & 500 error messages
 */
const ErrorMessage = ({
  code,
  router,
}) => {
  const dispatch = useDispatch();
  const onGoBack = () => {
    dispatch(clearError);
    router.goBack();
  };

  return (
    <div className="margin-2-tb" role="alert">
      {!code ? (<ProgressCircular />)
        : (
          <div className="flex flex-column flex-justify-center text-align-center">
            <IconWarning isFilled={true} size="lg" color="caution" />
            <Heading className="margin-1-tb" level={4} variant="sans-xsmall-medium">
              <FormattedMessage id={`${code}_heading`} />
            </Heading>
            <p className="body-3">
              <FormattedMessage id={`${code}_message`} />
            </p>
            <ul className={clsx(styles.list, 'list-links-inline-separator margin-2-t')}>
              <li className={styles.listItem}>
                <BackLink onClick={onGoBack} tabIndex="0">
                  <FormattedMessage id="previousPage" />
                </BackLink>
              </li>
              <li className={styles.listItem}>
                <Link href="/">
                  <FormattedMessage id="homePage" />
                </Link>
              </li>
            </ul>
          </div>
        )}
    </div>
  );
};

ErrorMessage.propTypes = {
  code: PropTypes.oneOf(['404', '500']),
  router: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
  }).isRequired,
};

export function mapStateToProps(state, ownProps) {
  return {
    code: ownProps.code || state.getIn(['error', 'code']),
  };
}

const hocChain = compose(connect(mapStateToProps), withRouter);

export { ErrorMessage as TestableErrorMessage };

export default hocChain(ErrorMessage);
